var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import isEqual from "lodash/isEqual";
import { DEFAULT_CO_EDITION_REQUEST_STATUSES } from "../utils/filterDefaults";
import { appendSelectionParams, sameSelection, selectionFromParams, toggleRequiredSelection, } from "../utils/requiredSelection";
// Without a statuses param the list shows the default (pending requests only).
var statusesFromSearch = function (search) {
    return selectionFromParams(new URLSearchParams(search), "statuses", DEFAULT_CO_EDITION_REQUEST_STATUSES);
};
export var useCoEditionRequestFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    // Initialised from the URL in the first render: filters patched in by an
    // effect afterwards would change the search and send it twice.
    var _b = useState(function () { return ({
        statuses: statusesFromSearch(location.search),
    }); }), filters = _b[0], setFilters = _b[1];
    var updateUrlWithFilters = function (next) {
        var params = new URLSearchParams();
        appendSelectionParams(params, "statuses", next.statuses, DEFAULT_CO_EDITION_REQUEST_STATUSES);
        history.push({ search: params.toString() });
    };
    // The URL is pushed outside the state updater: StrictMode runs updaters
    // twice, which pushed every toggle into the history twice.
    // The filters including toggles not rendered yet: two toggles before a
    // re-render must both count.
    var latestFiltersRef = useRef(filters);
    latestFiltersRef.current = filters;
    var handleStatusChange = function (status) {
        var current = latestFiltersRef.current;
        var toggled = toggleRequiredSelection(current.statuses, status);
        if (toggled === current.statuses)
            return;
        // one order for one selection: unchecking and re-checking an option must
        // not turn into a search for the same statuses in another order
        var statuses = __spreadArray([], toggled, true).sort();
        var next = __assign(__assign({}, current), { statuses: statuses });
        latestFiltersRef.current = next;
        setFilters(next);
        updateUrlWithFilters(next);
    };
    // Back/forward or a pasted URL: the URL is the applied filters.
    useEffect(function () {
        var fromUrl = statusesFromSearch(location.search);
        setFilters(function (prev) {
            return isEqual(prev.statuses, fromUrl) ? prev : { statuses: fromUrl };
        });
    }, [location.search]);
    var isAnyFilterActive = !sameSelection(filters.statuses, DEFAULT_CO_EDITION_REQUEST_STATUSES);
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (v) { return !v; }); };
    var handleClearFilters = function () {
        setFilters({ statuses: DEFAULT_CO_EDITION_REQUEST_STATUSES });
        history.push({ search: "" });
    };
    return {
        filters: filters,
        setFilters: setFilters,
        filterPaneIsVisible: filterPaneIsVisible,
        toggleFilterPane: toggleFilterPane,
        handleStatusChange: handleStatusChange,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
    };
};
